import type {
  RestAdminResellerTopListResponse,
  RestResellerTopListResponse,
} from "@KassaroAB/shared/types/resellerTopList";
import type { ResellerId } from "@KassaroAB/shared/types/ids";
import { api } from "../utils/api";

const DEFAULT_RESELLER_TOP_LIMIT = 10;

export const getAdminResellerTopListApi = async (
  month?: string
): Promise<RestAdminResellerTopListResponse> => {
  const params = new URLSearchParams();
  if (month) {
    params.set("month", month);
  }
  const query = params.toString();
  return api.get<RestAdminResellerTopListResponse>(
    query ? `admin/stats/top-list?${query}` : "admin/stats/top-list"
  );
};

export const getResellerTopListApi = async (
  resellerId: ResellerId,
  month?: string,
  limit: number = DEFAULT_RESELLER_TOP_LIMIT
): Promise<RestResellerTopListResponse> => {
  const params = new URLSearchParams({
    limit: limit.toString(),
  });
  if (month) {
    params.set("month", month);
  }
  return api.get<RestResellerTopListResponse>(
    `resellers/${resellerId}/stats/top-list?${params.toString()}`
  );
};
